export default "__VITE_ASSET__C96JEBIZ__"